import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent implements OnInit {

  @Input() title: string;
  @Input() remark_inner: string;
  @Input() active: boolean;

  constructor() {
  }

  ngOnInit() {
  }

  toggle = (event): void => {
    let container = event.currentTarget;
    let content = event.currentTarget.nextSibling;
    container.classList.toggle('open');
    content.classList.toggle('open');
    let other = Array.from(document.getElementsByClassName('dropdown-title')).filter(value => value.classList.contains('open'));
    if (other.length !== 1) {
      for (let item of other as HTMLElement[]) {
        if (item !== event.target) {
          item.classList.remove('open');
          let item_content = <Element> item.nextSibling;
          item_content.classList.remove('open');
        }
      }
    }

  }

}
